@if (CompanyId) {
  <div class="container-fluid d-flex flex-column h-100">
    <div class="row">
      <div class="col">
        <label class="fs-32">{{ title }}</label>
      </div>
    </div>
    <div class="row flex-grow-1">
      <div class="col">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
}
